<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence'
import PersonalPieChart from './PersonalPieChart.vue'
import PersonalityKeyword from './PersonalityKeyword.vue'

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const dataGathering = computed(() => splitBySentence(props.pData.관계방식.기본특성))
const infoGathering = computed(() => splitBySentence(props.pData.관계방식.상세특성))
const strengthItems = computed(() => splitCommaSeparatedWords(props.pData.관계방식.주요강점))
const weaknessItems = computed(() => splitCommaSeparatedWords(props.pData.관계방식.주요약점))
const strengthDetail = computed(() => splitBySentence(props.pData.관계방식.강점설명))
const weaknessDetail = computed(() => splitBySentence(props.pData.관계방식.약점설명))
const strengthAdvice = computed(() => props.pData.관계방식.강점조언)
const weaknessAdvice = computed(() => props.pData.관계방식.약점조언)

const nCodeData = computed(() => props.pData.낭만성향.성향분포.NCODE_RTOS['pj_rto'])
const parsedPJ = computed(() => {
  const type = nCodeData.value[0]
  const value = Number(nCodeData.value[1]) || 0
  let p = 0
  let j = 0
  if (type === 'P') {
    p = value
    j = 100 - p
  } else if (type === 'J') {
    j = value
    p = 100 - j
  }
  return { p, j }
})
const eiChartData = computed(() => ({
  'P (적 성향)': parsedPJ.value.p.toFixed(1),
  'J (적 성향)': parsedPJ.value.j.toFixed(1),
}))
const eiLabelList = ['P (적 성향)', 'J (적 성향)']
const eiColorMap = {
  'P (적 성향)': '#FFB401',
  'J (적 성향)': '#4881CE',
}
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">8</span>
          <span class="detail-tit__txt personality">나의 관계 스타일!</span>
        </div>
        <div class="personality-wrapper">
          <div class="person-content-box">
            <div class="personality-chart__wrapper">
              <PersonalPieChart
                :chartData="eiChartData"
                :labelList="eiLabelList"
                :colorMap="eiColorMap"
                centerTitle="관계방식"
                labelDirection="row"
              />
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <PersonalityKeyword
              :left-title="['관계를 바라보는', '나의 핵심 키워드 😊']"
              :keywords="props.pData.관계방식.주요특징"
              :isMobile="isMobile"
            />
          </div>
          <div class="personality-divider" />

          <div class="person-content-box">
            <div class="content__title">🤝 나의 관계 방식 스타일은?</div>
            <div v-for="(sentence, idx) in dataGathering" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <!-- <div class="content__title">

            </div> -->
            <div v-for="(sentence, idx) in infoGathering" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">💪 이런 키워드가 나의 강점을 말해줘요.</div>
            <div class="desc__body blue">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in strengthItems" :key="idx" class="keyword-item blue">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in strengthDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">강점을 활용해 보세요. 😊</div>
                <div class="white-box__desc">
                  {{ strengthAdvice }}
                </div>
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">👀 조금 더 살펴보세요.</div>
            <div class="desc__body red">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in weaknessItems" :key="idx" class="keyword-item red">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in weaknessDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">한걸음 나아가면! 😉</div>
                <div class="white-box__desc">
                  {{ weaknessAdvice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
